module.exports = __webpack_public_path__ + "img/testconfigicon.a4c599ae.svg";